import "mapbox-gl/dist/mapbox-gl.css";
import React, { useState } from "react";
import ReactMapGL, { FullscreenControl, NavigationControl, Marker, Popup } from "react-map-gl";
import RoomIcon from "@material-ui/icons/Room";
import { css } from "emotion";

import styleConfig from "styles/styleConfig";

const { colors } = styleConfig;

const fullscreenControlStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px;
`;

const navStyle = css`
  position: absolute;
  top: 36;
  left: 0;
  padding: 10px;
`;

interface Props {}

const Map: React.FC<Props> = () => {
  const location = { latitude: 51.07072, longitude: 3.70985 };
  const [viewState, setViewState] = useState({
    latitude: 51.05861335665429,
    longitude: 3.722731245937696,
    zoom: 11,
    pitch: 45,
    altitude: 1.5,
    minZoom: 9,
  });
  return (
    <div id="map">
      <ReactMapGL
        viewState={viewState}
        onViewStateChange={({ viewState }: any) => setViewState(viewState)}
        width={500}
        height={400}
        mapStyle="mapbox://styles/mapbox/light-v8"
        mapboxApiAccessToken="pk.eyJ1IjoiaXNtYWlsa3V0bHUiLCJhIjoiY2puZnhmcG4xMDRqNDN2cW51anZqbWw4ciJ9.OCevkqersBrpBN3jhIl1Xw"
      >
        <Marker latitude={location.latitude} longitude={location.longitude} offsetLeft={-10.5} offsetTop={-12}>
          <RoomIcon height={20} style={{ color: colors.black }} />
        </Marker>
        <Popup
          latitude={location.latitude}
          longitude={location.longitude}
          closeButton={false}
          closeOnClick={false}
          offsetTop={-30}
          anchor="bottom"
        >
          <div>
            <strong>Erba Supermarkt</strong>
            <p>
              <small>Frans van Ryhovelaan 148, 9000 GENT</small>
            </p>
          </div>
        </Popup>
        <div className={fullscreenControlStyle}>
          <FullscreenControl />
        </div>
        <div className={navStyle}>
          <NavigationControl />
        </div>
      </ReactMapGL>
    </div>
  );
};

export default Map;
